import { Component, input, output } from '@angular/core';
import { ClozeTestStyleModel } from '../model/cloze-test-style-model';

@Component({
  selector: 'cloze-test-introduction-short',
  templateUrl: './introduction-short.component.html',
  styleUrls: ['./introduction-short.component.scss'],
  standalone: true,
  imports: [],
})
export class IntroductionShortComponent {
  readonly clozeTestStyleModel = input({} as ClozeTestStyleModel);
  readonly lang = input('de');
  readonly mobileMode = input(false);
  readonly showExerciseExample = input(false);

  readonly startTest = output<boolean>();
  readonly startTestExample = output<void>();

  onStartTest(): void {
    if (this.showExerciseExample()) {
      this.startTestExample.emit();
    } else {
      this.startTest.emit(true);
    }
  }
}
